export enum Pais {
  COLOMBIA = 'Colombia',
}
